<template>
  <div
    ref="skipContent"
    class="skipto"
  >
    <button
      v-if="nextFocusable"
      class="skip"
      :aria-label="skipLabel"
      @click="focusNext"
    >
      <span
        class="skip__text"
        v-text="skipLabel"
      />
    </button>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'SkipTo',
    props: {
      skipLabel: { type: String, required: false, default: 'Skip this section' },
      skipToId: { type: String, required: false, default: '' }
    },
    data() {
      return {
        skipId: 'skip-content',
        next: null,
        nextFocusable: null
      };
    },
    mounted() {
      this.next = this.$refs.skipContent.nextElementSibling;
      const idEl = document.getElementById(this.skipToId);
      this.nextFocusable = idEl || this.getNextFocusable() || document.querySelector('footer');
    },
    methods: {
      getNextFocusable() {
        if (!this.next) {
          return;
        }
        const nextSibling = this.getHeading(this.next);
        this.next = this.next.nextElementSibling ? this.next.nextElementSibling : null;
        return nextSibling ? nextSibling : this.getNextFocusable();
      },
      getHeading(el) {
        const anyHeading = el.querySelectorAll('h1,h2,h3,h4,h5,h6');
        return anyHeading.length ? anyHeading[0] : null;
      },
      focusNext() {
        this.nextFocusable.setAttribute('tabindex', '-1');
        this.nextFocusable.focus();
      }
    }
  };
</script>

<style src="./SkipTo.scss" lang="scss">
